import { render, staticRenderFns } from "./OrdersProcessing.vue?vue&type=template&id=adb288a8"
import script from "./OrdersProcessing.vue?vue&type=script&lang=js"
export * from "./OrdersProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports